// markup/readOnly.mjs — a saved markup doc as the read-only controller MarkupLayer draws.
// ---------------------------------------------------------------------------
// 2026-09-15 — Brett: "The report doesnt show the correct colour pins, the
// legend, or the markup area." The shared report has no editing controller
// (useMarkup is the signed-in editor, with history, keys and saving). It needs
// only what MarkupLayer reads when readOnly: the objects, the scale and unit to
// label them with, and inert editing state. The doc goes through deserialize, so
// a report shows exactly what the allow-list keeps — the same as the app.
// ---------------------------------------------------------------------------

import { deserialize } from './model.mjs';

//
// v0.304.0 — Brett: "hide the m2 on the client report". opts.figures === false
// drops the take-off figures: no area / length chip on a measured mark
// (hideFigures, read by MarkupLayer) and no totals column on a Legend stamp.
// The shapes and their colours stay.
export function readOnlyMarkup(doc, opts = {}) {
  const d = deserialize(doc && typeof doc === 'object' ? doc : {});
  const figures = opts.figures !== false;
  return {
    objects: figures ? d.objects : d.objects.map((o) => (o.type === 'legend' ? { ...o, totals: false } : o)),
    hideFigures: !figures,
    calibration: d.calibration,
    unit: d.unit || 'm',
    count: d.objects.length,
    // Inert editing state: nothing selected, nothing armed, nothing to register.
    selectedIds: [],
    tool: 'pan',
    measureKind: 'length',
    markType: null,
    snapGrid: false,
    drawStyle: { stroke: '#e8650a', strokeWidth: 2 },
    registerCommand: null,
  };
}
